/**
 * Servicio optimizado para agregar y quitar chats no leídos por plataforma.
 * Opera sobre grandes volúmenes usando Map para O(1) en búsquedas y elimina duplicados por id.
 */
class UnreadChatsService {
  /**
   * Agrega un chat al array de la plataforma indicada, evitando duplicados por id.
   * El chat se inserta al inicio del array.
   * @param {Object} data - Objeto data con arrays por plataforma
   * @param {string} platform - Nombre de la plataforma (ej: 'whatsapp')
   * @param {Object} chat - Objeto chat a agregar (debe tener id)
   * @returns {Object} Nuevo objeto data actualizado
   */
  static addChat(data, platform, chat) {
    if (!chat || !chat.id) return data;
    const arr = Array.isArray(data[platform]) ? data[platform] : [];
    const idStr = String(chat.id);
    // Si ya existe un chat con ese id, no agregarlo de nuevo
    if (arr.some(item => String(item.id) === idStr)) {
      return data;
    }
    // Insertar al inicio y mantener unicidad por id
    const idSet = new Set([idStr]);
    const newArr = [chat, ...arr.filter(item => {
      const itemId = String(item.id);
      if (idSet.has(itemId)) return false;
      idSet.add(itemId);
      return true;
    })];
    return { ...data, [platform]: newArr };
  }

  /**
   * Elimina un chat por id del array de la plataforma indicada.
   * @param {Object} data - Objeto data con arrays por plataforma
   * @param {string} platform - Nombre de la plataforma
   * @param {string|number} id - ID del chat a eliminar
   * @returns {Object} Nuevo objeto data actualizado
   */
  static removeChat(data, platform, id) {
    if (!id) return data;
    const arr = Array.isArray(data[platform]) ? data[platform] : [];
    const idStr = String(id);
    const newArr = arr.filter(item => String(item.id) !== idStr);
    return { ...data, [platform]: newArr };
  }
}

export default UnreadChatsService;
